export const VehicleTransferBusinessSceneTranslation = {
  fi: {
    VehicleTransferBusinessScene: {
      title: 'Siirrä ajoneuvo yritykselle',
    },
  },
};
